"use strict";
// Who ordered an urban study — the canonical catalogue.
//
// `urban_analysis.requestor` is an FK to `public.account_types`, which has FIVE
// rows (it is the account-type catalogue). The PRODUCT recognises only FOUR of
// them as ordering parties. `SOCIETY` is a perfectly valid account type and is
// NOT a valid requestor: a company works its salesmen's dossiers (#379), so when
// it orders a study it orders on the commercial side's behalf.
//
// The database cannot express that distinction — the FK points at the five-member
// table — so it is enforced here, at the one place every writer goes through.
// Issue #581 is exactly what happens when it is not: a company's order was
// written as `SOCIETY`, and every rule that asks "is this study the commercial
// side's" read it as no study at all — the hub row, the projects-list card, the
// type-validation warning, the documents gate and the Arthur billing query.
//
// Single source of truth for the four values. The Zod schemas at both boundaries
// (`backend/.../project-management/schemas`, `backend/.../urban-analysis/schemas/
// create-standalone`, `frontend/.../urban-analysis/schemas/createUrbanAnalysis`)
// and the dashboard's row type all derive from it, so they cannot drift.
Object.defineProperty(exports, "__esModule", { value: true });
exports.urbanAnalysisRequestorForRole = exports.URBAN_ANALYSIS_REQUESTORS = exports.URBAN_ANALYSIS_REQUESTOR = void 0;
const URBAN_ANALYSIS_REQUESTOR_LITERAL = {
    ARCHITECT: 'ARCHITECT',
    COLLABORATOR: 'COLLABORATOR',
    SALESMAN: 'SALESMAN',
    CLIENT: 'CLIENT',
};
exports.URBAN_ANALYSIS_REQUESTOR = URBAN_ANALYSIS_REQUESTOR_LITERAL;
/**
 * The four recognised ordering parties, as a tuple — the shape `z.enum()` wants.
 * Boundary schemas spread this rather than re-typing the literals.
 */
exports.URBAN_ANALYSIS_REQUESTORS = [
    'ARCHITECT',
    'COLLABORATOR',
    'SALESMAN',
    'CLIENT',
];
/**
 * The ordering party to record for a caller acting in `role`.
 *
 * Total over every account type, which is the point: no caller can produce a
 * value outside `URBAN_ANALYSIS_REQUESTORS`.
 *
 * `SOCIETY` maps to `SALESMAN` — a company ordering a study is the commercial
 * side ordering it. That is not a workaround: the study is attached to a project
 * owned by one of the company's salesmen, `salesman_id` is copied from that
 * project at creation, and the hub's own study-creation form
 * (`HubUrbanAnalysisCreate`) has always recorded `SALESMAN` for the company.
 *
 * NOTE: this decides who is recorded as ORDERING the study, not who may order
 * one. Authorisation is `ResourceAccessService`'s job, and the architect-side
 * override (an architect naming the client or the commercial as the ordering
 * party) is applied by the route BEFORE this function is reached.
 *
 * Switched on string literals rather than `AccountType.*`, whose members are
 * deliberately typed as the whole union — see the note in `account-type.ts`.
 * The literals are what make this switch exhaustive over `AccountTypeType`.
 */
const urbanAnalysisRequestorForRole = (role) => {
    switch (role) {
        case 'SOCIETY':
            return exports.URBAN_ANALYSIS_REQUESTOR.SALESMAN;
        case 'ARCHITECT':
            return exports.URBAN_ANALYSIS_REQUESTOR.ARCHITECT;
        case 'COLLABORATOR':
            return exports.URBAN_ANALYSIS_REQUESTOR.COLLABORATOR;
        case 'SALESMAN':
            return exports.URBAN_ANALYSIS_REQUESTOR.SALESMAN;
        case 'CLIENT':
            return exports.URBAN_ANALYSIS_REQUESTOR.CLIENT;
    }
};
exports.urbanAnalysisRequestorForRole = urbanAnalysisRequestorForRole;
//# sourceMappingURL=urban-analysis-requestor.js.map